import { useAuthContext } from "auth/authProvider";
import Landing from "components/landing";
import { useEffect } from "react";

export default function UserProvider(props: Readonly<React.PropsWithChildren>) {
  const { children } = props;

  const { login } = useAuthContext();
  const { user, isLoading } = useAuthContext();

  useEffect(() => {
    if (!isLoading && !user) login();
  }, [user, isLoading, login]);

  if (user) {
    return children;
  }

  return <Landing />;
}
